<template>
    <div>
        <app-sub-title text="Asignación de Item al cliente" />
        <b-row class="mb-3">
            <b-col cols="12">
                <app-autocomplete
                    v-model="theClient"
                    placeholder="Cliente"
                    :items="clients"
                    @input="loadAccessPointsByClient"
                >
                </app-autocomplete>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-alert
                    variant="success"
                    v-if="!accessPoints.length && theClient"
                    show
                    >¡No hay datos!</b-alert
                >
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-access-point-list
                    @unassign-tool="startUnassign"
                    :data="accessPoints"
                    :to-assign="startToAssign"
                />
            </b-col>
        </b-row>

        <!-- INICIO popUp's -->
        <app-pop-up
            title="Asignación de herramientas"
            id="toassign-items"
            size="extra-large"
            :onClose="cleanFilters"
        >
            <div slot="body">
                <app-item-filters @filter="onFilter" :item-types="itemTypes" />
                <app-unassigned-tools-list
                    :data="availableItems"
                    :to-assign="toAssignItem"
                    :on-change-page="onChangePage"
                />
            </div>
        </app-pop-up>

        <app-pop-up title="desasignación de herramientas" id="unassign-item">
            <div slot="body">
                <h3>Esta seguro que desea desasignar esta herramienta?</h3>
            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" @click="unassignItem">
                    Aceptar
                </button>
            </div>
        </app-pop-up>
        <!-- FIN popUp's -->
    </div>
</template>
<script>
import structuresRepository from '../../../repositories/structures.repository.js'
import itemsRepository from '../../../repositories/items.repository.js'
import AccessPointList from './AccessPointsList/AccessPointsList.vue'
import UnassignedToolsList from './UnassignedToolsList/UnassignedToolsList.vue'
import ItemFilters from '../Items/ItemsFilters/ItemsFilters.vue'
// import Autocomplete from '../../UI/Controls/AutocompleteV2/Autocomplete'
import { mapGetters } from 'vuex'

export default {
    components: {
        appAccessPointList: AccessPointList,
        appUnassignedToolsList: UnassignedToolsList,
        appItemFilters: ItemFilters,
        // appAutocomplete: Autocomplete,
    },

    data() {
        return {
            accessPoints: [],
            availableItems: '',
            clients: [],
            filters: null,
            pageAvailableItems: 1,
            selectAccessPoint: '',
            selectItem: '',
            theClient: '',
        }
    },
    computed: {
        ...mapGetters(['itemTypes']),
    },
    methods: {
        async loadClients() {
            const { data } = await repo.get('clients/list')
            this.clients = data
        },
        loadAccessPointsByClient(client) {
            const sr = Object.assign({}, structuresRepository)
            sr.accessPointsByClient(client.id)
                .then(data => {
                    this.accessPoints = data
                })
                .catch(error => {
                    toastr.error(
                        'Error al cargar los puntos de acceso para asignar las herramientas'
                    )
                })
        },
        loadAvailableTools() {
            const filters = this.filters
            const ir = Object.assign({}, itemsRepository)
            ir.getAvailableItems(filters, this.pageAvailableItems)
                .then(data => {
                    this.availableItems = data
                })
                .catch(error => {
                    toastr.error('Error al cargar las herramientas disponibles')
                })
        },
        onChangePage(page) {
            this.pageAvailableItems = page
            this.loadAvailableTools()
        },
        onFilter(filters) {
            this.filters = filters
            this.pageAvailableItems = 1
            this.loadAvailableTools()
        },
        resetFilters(filters) {
            this.loadAvailableTools()
        },
        cleanFilters() {
            this.$bus.$emit('filters.clean')
        },
        startToAssign(accessPoint) {
            this.loadAvailableTools()
            this.selectAccessPoint = accessPoint
            this.$bus.$emit('toassign-items.open')
        },
        toAssignItem(item) {
            const formData = new FormData()
            const self = this
            formData.append('accessPointId', this.selectAccessPoint.id)
            formData.append('itemId', item.id)
            const ir = Object.assign({}, itemsRepository)
            ir.assignStructure(formData)
                .then(data => {
                    if (data.status) {
                        self.cleanFilters()
                        self.loadAvailableTools()
                        self.loadAccessPointsByClient(self.theClient)
                        toastr.success(data.msg)
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Error al asignar la herramienta')
                })
        },
        startUnassign(item) {
            this.selectItem = item
            this.$bus.$emit('unassign-item.open')
        },
        unassignItem() {
            const self = this
            const ir = Object.assign({}, itemsRepository)
            ir.unassignStructure(this.selectItem.id)
                .then(data => {
                    if (data.status) {
                        self.loadAccessPointsByClient(self.theClient)
                        toastr.success(data.msg)
                        self.$bus.$emit('unassign-item.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('Error al desasignar la herramienta')
                })
        },
    },
    mounted() {
        // this.load('clients');
        this.loadClients()
        this.load('itemTypes')
    },
}
</script>
